import axios from 'axios';
import InitAuthorization from '../common/auth/interceptors/Authorization';
import InitAuthorizationResponse
  from '../common/auth/interceptors/AuthorizationResponse';
import Forbidden from '../common/auth/interceptors/Forbidden';

import LanguageHeader from '../lang/interceptors/LanguageHeader';

axios.defaults.baseURL = process.env.APP_URL;

InitAuthorization(axios);
InitAuthorizationResponse(axios);
LanguageHeader(axios);
Forbidden(axios);

export default axios;



// WEBPACK FOOTER //
// ./src/config/axios.js